export function decodeBase64(value) {
  try {
    return decodeURIComponent(
      escape(atob(value))
    );
  } catch {
    return "";
  }
}